module.exports = __webpack_public_path__ + "img/microcine.c9fe9e2f.svg";